export const DATE_FORMAT = "YYYY-MM-DD";
export const PC = "PC";
export const MOBILE = "MOBILE";
export const IPAD = "IPAD";